import styled from 'styled-components'

export const StyledComingSoon = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 100%;

  .comingsoon-content{
    img {
      max-width: 40%;
    }
    text-align: center;
  }
  .title-page{
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    text-align: center;
    color: #00081D;
    margin-bottom: 0.5rem;
  }
  .content-page{
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #7C88A6;
  }
`
